import { Link } from "react-router-dom";
import NavbarVoltar from "../NavbarVoltar";

const Termos = () => {
  return (
    <div className="bg-white">
      <div className="relative z-50">
        <NavbarVoltar />
      </div>

      <div className="relative isolate px-6 lg:px-8">
        <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          ></div>
        </div>

        <div className="mx-auto max-w-4xl py-16 text-gray-900">
          <h1 className="mb-8 text-center text-4xl font-bold tracking-tight">
            Termos de Uso
          </h1>
          <div className="space-y-6 text-lg leading-7">
            <p>
              Bem-vindo à <strong>Vintree</strong>. Estes Termos de Uso
              regulam o acesso e a utilização da plataforma, incluindo a criação
              de vitrines digitais, cadastro de produtos, análise de visitas,
              integrações de marketing e envio de notificações pelo navegador.
              Ao criar uma conta ou utilizar os serviços, você declara que leu,
              compreendeu e concorda com estes Termos e com a{" "}
              <Link
                to="/politicas"
                className="text-fuchsia-700 underline hover:text-fuchsia-900"
              >
                Política de Privacidade
              </Link>
              .
            </p>

            <p className="text-sm text-gray-600">Última atualização: 20/08/2026.</p>

            <h2 className="text-2xl font-semibold">1. Aceitação e Elegibilidade</h2>
            <p>
              1.1. O usuário deve possuir capacidade legal para contratar e,
              quando cadastrar uma loja, declarar que é titular, representante
              legal ou pessoa autorizada a administrar a vitrine e os canais
              comerciais vinculados.
            </p>
            <p>
              1.2. A Vintree poderá atualizar estes Termos para refletir
              melhorias do produto, mudanças operacionais ou exigências legais.
              Mudanças relevantes serão comunicadas por meios razoáveis.
            </p>

            <h2 className="text-2xl font-semibold">2. Conta, Cadastro e Segurança</h2>
            <p>
              2.1. O usuário é responsável por fornecer informações verdadeiras,
              completas e atualizadas. Dados falsos, incompletos ou enganosos
              poderão resultar em limitação, suspensão ou encerramento da conta.
            </p>
            <p>
              2.2. O usuário é responsável por manter a confidencialidade de
              suas credenciais, controlar acessos à conta e comunicar
              imediatamente qualquer suspeita de uso indevido.
            </p>

            <h2 className="text-2xl font-semibold">3. Uso da Plataforma</h2>
            <p>
              3.1. A Vintree fornece ferramentas para criação e gestão de
              vitrines digitais. A venda, entrega, disponibilidade, preço,
              qualidade, garantia, troca, atendimento ao consumidor e
              regularidade dos produtos anunciados são de responsabilidade
              exclusiva do lojista.
            </p>
            <p>
              3.2. É proibido utilizar a plataforma para publicar, vender,
              promover ou direcionar usuários a conteúdo, produto, serviço ou
              prática ilegal, enganosa, fraudulenta, abusiva, discriminatória,
              ofensiva, pornográfica, violenta, que viole direitos de terceiros
              ou que possa prejudicar consumidores, a Vintree ou terceiros.
            </p>
            <p>
              3.3. Também é proibido utilizar a plataforma para phishing,
              malware, scraping abusivo, manipulação de métricas, violação de
              propriedade intelectual, coleta indevida de dados pessoais,
              divulgação de dados sensíveis sem base legal ou qualquer tentativa
              de burlar limites técnicos, comerciais ou de segurança.
            </p>
            <p>
              3.4. A Vintree é uma ferramenta de vitrine digital e catálogo
              visual. A plataforma não atua como marketplace, intermediadora de
              pagamento, carrinho de compras, checkout, adquirente, representante
              comercial ou parte na relação de consumo entre lojista e visitante.
              Quando uma venda ocorrer fora da plataforma, presencialmente, pelo
              WhatsApp, redes sociais, telefone, site próprio ou outro canal, a
              negociação, contratação e cumprimento das obrigações legais cabem
              exclusivamente ao lojista.
            </p>

            <h2 className="text-2xl font-semibold">
              4. Produtos, Preços e Informações Comerciais
            </h2>
            <p>
              4.1. A plataforma pode oferecer campos para preço, descrição,
              fotos, variações, links e outras informações do produto. Esses
              campos são recursos disponibilizados ao lojista, que decide como
              preenchê-los e é o único responsável por manter as informações
              corretas, claras, verdadeiras e compatíveis com a legislação
              aplicável.
            </p>
            <p>
              4.2. A existência de campo de preço na Vintree não transforma a
              plataforma em comércio eletrônico, checkout, anúncio patrocinado,
              proposta vinculante da Vintree ou responsável pela oferta. O
              lojista deve avaliar, conforme seu modelo de venda, canal de
              atendimento, tipo de produto, localização e legislação aplicável,
              quais informações devem ser exibidas ao consumidor antes da
              conclusão da venda.
            </p>
            <p>
              4.3. A Vintree funciona como canal de comunicação e vitrine
              visual, semelhante a perfis, posts, catálogos digitais e outros
              materiais comerciais usados para aproximar lojistas e consumidores.
              A permanência de fotos ou produtos na vitrine não significa,
              necessariamente, estoque em tempo real, reserva, disponibilidade
              imediata, oferta vigente ou obrigação de venda pela Vintree. O
              consumidor deve confirmar condições atuais, disponibilidade, preço,
              prazo, forma de pagamento e demais detalhes diretamente com o
              lojista no canal de atendimento indicado.
            </p>
            <p>
              4.4. Caso o lojista opte por ocultar preço, informar preço sob
              consulta, exibir preço promocional, alterar preço, indicar
              disponibilidade, usar imagens meramente ilustrativas ou direcionar
              o visitante para negociação em outro canal, ele assume integral
              responsabilidade por cumprir o Código de Defesa do Consumidor,
              normas de oferta e precificação, regras de comércio eletrônico
              quando aplicáveis, regras de publicidade e demais normas
              consumeristas.
            </p>
            <p>
              4.5. A Vintree poderá remover, limitar ou solicitar ajuste de
              anúncios, vitrines, produtos ou conteúdos que apresentem indícios
              de informação falsa, preço enganoso, omissão abusiva, divergência
              relevante, produto ilegal, reclamações recorrentes ou risco legal,
              sem que isso implique dever de fiscalização prévia de todos os
              conteúdos publicados por lojistas.
            </p>

            <h2 className="text-2xl font-semibold">
              5. Notificações, Marketing e Comunicações
            </h2>
            <p>
              5.1. Quando disponível no plano contratado, o lojista poderá
              enviar notificações pelo navegador apenas a visitantes que tenham
              autorizado expressamente o recebimento para aquela loja. A
              permissão é concedida pelo navegador do visitante e pode ser
              cancelada a qualquer momento.
            </p>
            <p>
              5.2. O lojista é responsável pelo conteúdo, frequência,
              finalidade, veracidade e licitude das notificações, mensagens,
              campanhas, links, pixels, tags e integrações de marketing que
              configurar ou disparar pela plataforma.
            </p>
            <p>
              5.3. É proibido enviar spam, comunicações enganosas, mensagens com
              urgência falsa, promoções inexistentes, conteúdo ofensivo,
              conteúdo sensível sem base legal, links maliciosos ou qualquer
              comunicação que viole legislação aplicável, direitos de titulares
              de dados, regras de plataformas terceiras ou boas práticas de
              relacionamento com consumidores.
            </p>
            <p>
              5.4. A Vintree poderá limitar, bloquear, revisar ou suspender o
              uso de notificações e integrações quando identificar abuso, risco
              legal, reclamações recorrentes, fraude, envio excessivo, violação
              destes Termos ou prejuízo à reputação e operação da plataforma.
            </p>

            <h2 className="text-2xl font-semibold">6. Planos, Limites e Recursos</h2>
            <p>
              6.1. Recursos, limites de armazenamento, quantidade de produtos,
              análises, notificações, inscritos e campanhas podem variar conforme
              o plano contratado. A Vintree poderá ajustar limites técnicos para
              preservar estabilidade, segurança e qualidade do serviço.
            </p>
            <p>
              6.2. Funcionalidades dependentes de serviços de terceiros, como
              navegadores, sistemas operacionais, gateways de pagamento,
              provedores de hospedagem, redes sociais e APIs externas, podem
              sofrer indisponibilidades, restrições ou mudanças fora do controle
              da Vintree.
            </p>

            <h2 className="text-2xl font-semibold">
              7. Privacidade e Proteção de Dados
            </h2>
            <p>
              7.1. O tratamento de dados pessoais pela Vintree ocorre conforme a
              Política de Privacidade. O lojista deve utilizar a plataforma de
              forma compatível com a legislação aplicável, incluindo a LGPD, e
              somente coletar, inserir, importar ou tratar dados quando possuir
              base legal adequada.
            </p>
            <p>
              7.2. Em relação aos dados de visitantes e clientes tratados por
              solicitação do lojista, o lojista permanece responsável pelas
              decisões sobre finalidade, conteúdo das campanhas e uso comercial
              das informações. A Vintree atua prestando a infraestrutura técnica
              da plataforma, sem validar previamente a legalidade de cada uso
              feito pelo lojista.
            </p>

            <h2 className="text-2xl font-semibold">8. Propriedade Intelectual</h2>
            <p>
              A Vintree, seus códigos, interfaces, marcas, textos, design,
              identidade visual, documentação e tecnologias são protegidos por
              direitos de propriedade intelectual. O uso da plataforma não
              transfere ao usuário qualquer direito sobre esses ativos.
            </p>

            <h2 className="text-2xl font-semibold">
              9. Moderação, Suspensão e Encerramento
            </h2>
            <p>
              A Vintree poderá remover conteúdo, limitar recursos, suspender
              notificações, bloquear integrações ou encerrar contas em caso de
              violação destes Termos, suspeita de fraude, risco à segurança,
              infração legal, inadimplência, reclamações relevantes ou uso que
              possa causar dano à plataforma, a consumidores ou a terceiros.
            </p>

            <h2 className="text-2xl font-semibold">10. Limitação de Responsabilidade</h2>
            <p>
              A Vintree não participa da negociação, venda, pagamento, entrega,
              troca ou garantia dos produtos anunciados pelos lojistas. A
              plataforma é fornecida como ferramenta tecnológica, sem garantia de
              aumento de vendas, alcance de campanhas, visualização efetiva de
              notificações ou disponibilidade ininterrupta.
            </p>
            <p>
              O usuário concorda em indenizar a Vintree por perdas, custos,
              reclamações, autuações, danos ou despesas decorrentes de uso
              indevido da plataforma, conteúdo publicado, campanhas enviadas,
              violação de direitos de terceiros, infração legal ou
              descumprimento destes Termos.
            </p>

            <h2 className="text-2xl font-semibold">11. Legislação Aplicável</h2>
            <p>
              Estes Termos são regidos pelas leis brasileiras. Em caso de
              disputa, fica eleito o foro da cidade de <strong>Catalão/GO</strong>,
              salvo quando a legislação aplicável determinar foro obrigatório
              diverso.
            </p>

            <p>
              Em caso de dúvidas, solicitações ou comunicações, entre em contato
              pelo e-mail:{" "}
              <a
                href="mailto:atendimento@vintree.com.br"
                className="text-fuchsia-700 underline"
              >
                atendimento@vintree.com.br
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Termos;
